import {
  p5 as classMeta,
  ga as VOID,
  o6 as setMetadataFor,
  t9 as THROW_ISE,
  a1 as Unit_getInstance,
  g9 as Enum,
  z5 as interfaceMeta,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class AglEditorLogger {
  constructor(bind) {
    this.bind = bind;
  }
  t4c(_set____db54di) {
    this.bind = _set____db54di;
  }
  u4c() {
    return this.bind;
  }
  log(level, message, t) {
    var tmp0_safe_receiver = this.bind;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$0;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'net.akehurst.language.editor.api.AglEditorLogger.log.<anonymous>' call
      tmp0_safe_receiver(level, message, t);
      tmp$ret$0 = tmp0_safe_receiver;
      tmp = tmp$ret$0;
    }
    return tmp;
  }
}
class LogLevel extends Enum {
  get name() {
    return this.be();
  }
  get ordinal() {
    return this.ce();
  }
  static get None() {
    return LogLevel_None_getInstance();
  }
  static get Fatal() {
    return LogLevel_Fatal_getInstance();
  }
  static get Error() {
    return LogLevel_Error_getInstance();
  }
  static get Warning() {
    return LogLevel_Warning_getInstance();
  }
  static get Information() {
    return LogLevel_Information_getInstance();
  }
  static get Debug() {
    return LogLevel_Debug_getInstance();
  }
  static get Trace() {
    return LogLevel_Trace_getInstance();
  }
  static get All() {
    return LogLevel_All_getInstance();
  }
}
class AglEditor {}
class EventStatus extends Enum {
  get name() {
    return this.be();
  }
  get ordinal() {
    return this.ce();
  }
  static get START() {
    return EventStatus_START_getInstance();
  }
  static get FAILURE() {
    return EventStatus_FAILURE_getInstance();
  }
  static get SUCCESS() {
    return EventStatus_SUCCESS_getInstance();
  }
}
class ParseEvent {
  constructor(status, message, tree, issues) {
    this.status = status;
    this.message = message;
    this.tree = tree;
    this.issues = issues;
    this.isStart = this.status.equals(EventStatus_START_getInstance());
    this.failure = this.status.equals(EventStatus_FAILURE_getInstance());
  }
  m4d() {
    return this.status;
  }
  j9() {
    return this.message;
  }
  i2d() {
    return this.tree;
  }
  w1b() {
    return this.issues;
  }
  n4d() {
    return this.isStart;
  }
  o4d() {
    return this.failure;
  }
}
class SyntaxAnalysisEvent {
  constructor(status, message, asm, issues) {
    this.status = status;
    this.message = message;
    this.asm = asm;
    this.issues = issues;
    this.isStart = this.status.equals(EventStatus_START_getInstance());
    this.failure = this.status.equals(EventStatus_FAILURE_getInstance());
  }
  m4d() {
    return this.status;
  }
  j9() {
    return this.message;
  }
  s1b() {
    return this.asm;
  }
  w1b() {
    return this.issues;
  }
  n4d() {
    return this.isStart;
  }
  o4d() {
    return this.failure;
  }
}
class SemanticAnalysisEvent {
  constructor(status, message, asm, issues) {
    this.status = status;
    this.message = message;
    this.asm = asm;
    this.issues = issues;
    this.isStart = this.status.equals(EventStatus_START_getInstance());
    this.failure = this.status.equals(EventStatus_FAILURE_getInstance());
  }
  m4d() {
    return this.status;
  }
  j9() {
    return this.message;
  }
  s1b() {
    return this.asm;
  }
  w1b() {
    return this.issues;
  }
  n4d() {
    return this.isStart;
  }
  o4d() {
    return this.failure;
  }
}
//endregion
var LogLevel_None_instance;
var LogLevel_Fatal_instance;
var LogLevel_Error_instance;
var LogLevel_Warning_instance;
var LogLevel_Information_instance;
var LogLevel_Debug_instance;
var LogLevel_Trace_instance;
var LogLevel_All_instance;
function values() {
  return [LogLevel_None_getInstance(), LogLevel_Fatal_getInstance(), LogLevel_Error_getInstance(), LogLevel_Warning_getInstance(), LogLevel_Information_getInstance(), LogLevel_Debug_getInstance(), LogLevel_Trace_getInstance(), LogLevel_All_getInstance()];
}
function valueOf(value) {
  switch (value) {
    case 'None':
      return LogLevel_None_getInstance();
    case 'Fatal':
      return LogLevel_Fatal_getInstance();
    case 'Error':
      return LogLevel_Error_getInstance();
    case 'Warning':
      return LogLevel_Warning_getInstance();
    case 'Information':
      return LogLevel_Information_getInstance();
    case 'Debug':
      return LogLevel_Debug_getInstance();
    case 'Trace':
      return LogLevel_Trace_getInstance();
    case 'All':
      return LogLevel_All_getInstance();
    default:
      LogLevel_initEntries();
      THROW_ISE();
      break;
  }
}
var LogLevel_entriesInitialized;
function LogLevel_initEntries() {
  if (LogLevel_entriesInitialized)
    return Unit_getInstance();
  LogLevel_entriesInitialized = true;
  LogLevel_None_instance = new LogLevel('None', 0);
  LogLevel_Fatal_instance = new LogLevel('Fatal', 1);
  LogLevel_Error_instance = new LogLevel('Error', 2);
  LogLevel_Warning_instance = new LogLevel('Warning', 3);
  LogLevel_Information_instance = new LogLevel('Information', 4);
  LogLevel_Debug_instance = new LogLevel('Debug', 5);
  LogLevel_Trace_instance = new LogLevel('Trace', 6);
  LogLevel_All_instance = new LogLevel('All', 7);
}
var EventStatus_START_instance;
var EventStatus_FAILURE_instance;
var EventStatus_SUCCESS_instance;
function values_0() {
  return [EventStatus_START_getInstance(), EventStatus_FAILURE_getInstance(), EventStatus_SUCCESS_getInstance()];
}
function valueOf_0(value) {
  switch (value) {
    case 'START':
      return EventStatus_START_getInstance();
    case 'FAILURE':
      return EventStatus_FAILURE_getInstance();
    case 'SUCCESS':
      return EventStatus_SUCCESS_getInstance();
    default:
      EventStatus_initEntries();
      THROW_ISE();
      break;
  }
}
var EventStatus_entriesInitialized;
function EventStatus_initEntries() {
  if (EventStatus_entriesInitialized)
    return Unit_getInstance();
  EventStatus_entriesInitialized = true;
  EventStatus_START_instance = new EventStatus('START', 0);
  EventStatus_FAILURE_instance = new EventStatus('FAILURE', 1);
  EventStatus_SUCCESS_instance = new EventStatus('SUCCESS', 2);
}
function LogLevel_None_getInstance() {
  LogLevel_initEntries();
  return LogLevel_None_instance;
}
function LogLevel_Fatal_getInstance() {
  LogLevel_initEntries();
  return LogLevel_Fatal_instance;
}
function LogLevel_Error_getInstance() {
  LogLevel_initEntries();
  return LogLevel_Error_instance;
}
function LogLevel_Warning_getInstance() {
  LogLevel_initEntries();
  return LogLevel_Warning_instance;
}
function LogLevel_Information_getInstance() {
  LogLevel_initEntries();
  return LogLevel_Information_instance;
}
function LogLevel_Debug_getInstance() {
  LogLevel_initEntries();
  return LogLevel_Debug_instance;
}
function LogLevel_Trace_getInstance() {
  LogLevel_initEntries();
  return LogLevel_Trace_instance;
}
function LogLevel_All_getInstance() {
  LogLevel_initEntries();
  return LogLevel_All_instance;
}
function EventStatus_START_getInstance() {
  EventStatus_initEntries();
  return EventStatus_START_instance;
}
function EventStatus_FAILURE_getInstance() {
  EventStatus_initEntries();
  return EventStatus_FAILURE_instance;
}
function EventStatus_SUCCESS_getInstance() {
  EventStatus_initEntries();
  return EventStatus_SUCCESS_instance;
}
//region block: post-declaration
setMetadataFor(AglEditorLogger, 'AglEditorLogger', classMeta);
setMetadataFor(LogLevel, 'LogLevel', classMeta);
setMetadataFor(AglEditor, 'AglEditor', interfaceMeta);
setMetadataFor(EventStatus, 'EventStatus', classMeta);
setMetadataFor(ParseEvent, 'ParseEvent', classMeta);
setMetadataFor(SyntaxAnalysisEvent, 'SyntaxAnalysisEvent', classMeta);
setMetadataFor(SemanticAnalysisEvent, 'SemanticAnalysisEvent', classMeta);
//endregion
//region block: exports
LogLevel.values = values;
LogLevel.valueOf = valueOf;
EventStatus.values = values_0;
EventStatus.valueOf = valueOf_0;
export {
  AglEditorLogger,
  LogLevel,
  EventStatus,
  ParseEvent,
  SyntaxAnalysisEvent,
  SemanticAnalysisEvent,
};
export {
  EventStatus_FAILURE_getInstance as a,
  EventStatus_START_getInstance as b,
  EventStatus_SUCCESS_getInstance as c,
  LogLevel_All_getInstance as d,
  LogLevel_Debug_getInstance as e,
  LogLevel_Error_getInstance as f,
  LogLevel_Fatal_getInstance as g,
  LogLevel_Information_getInstance as h,
  LogLevel_None_getInstance as i,
  LogLevel_Trace_getInstance as j,
  LogLevel_Warning_getInstance as k,
  AglEditorLogger as l,
  AglEditor as m,
  valueOf as n,
  ParseEvent as o,
  SemanticAnalysisEvent as p,
  SyntaxAnalysisEvent as q,
};
//endregion

//# sourceMappingURL=net.akehurst.language.editor-agl-editor-api.mjs.map
